<!-- Native-Angular port of account-v2/.../people/people.html.
     `ft-initialized-content` is dropped: hasLicense is set synchronously in
     ngOnInit, matching Stories — no init flash. `ft-branches` is replaced with
     a plain <nav>/<ul>/<li> that uses @uirouter/angular's uiSref/uiSrefActive,
     preserving the AngularJS DOM structure for pixel parity. -->
<div class="ft-view-body ft-people-body" *ngIf="hasLicense && platformStateService?.state?.hasAudience">
    <ft-main-nav />
    <ft-header [modifierClass]="'-people'">
        <div class="ft-content ft-container">
            <h1 class="ft-heading ft-text-plus-5">
                People
            </h1>
        </div>

        <nav class="ft-nav ft-navbar ft-sections-nav">
            <ul>
                <li uiSrefActive="active">
                    <a uiSref="people.directory">Directory</a>
                </li>
                <li uiSrefActive="active">
                    <a uiSref="people.feedback">Feedback</a>
                </li>
            </ul>
        </nav>

    </ft-header>

    <main class="ft-main ft-advocacy-main ft-scroll-anchor">
        <!-- WS5 router-severance: the prior note (that a plain <ui-view> can't host
             AngularJS children) was true only while people.feedback was AngularJS. All
             leaves are now native (directory/feedback + their *.details = Directory/
             Feedback/DetailsComponent), so a plain @uirouter/angular <ui-view> hosts them
             directly — removing the AngularJS <ft-ui-view-wrapper> $scope bridge that
             blocks a native router root. (people.directory already used native <ui-view>.) -->
        <ui-view />
    </main>
</div>
<div class="ft2" *ngIf="!hasLicense || !platformStateService?.state?.hasAudience">
    <div class="ft2-page-overlay bg-darker">
        <ft-main-nav [spacing]="true" />
        <section class="ft2-section">
            <div class="ft2-container">
                <div class="row f-nowrap">
                    <div class="col-5 col-md-7 col-sm-9 col-xs-12">
                        <div class="text-content mb-4">
                            <h1 class="h3">Put your audience on the right journey.</h1>
                            <p>
                                Powerful applications on your platform will work to inspire them as future prospects
                                or
                                invite them to collaborate with you to help grow your reach and convert new
                                audiences.
                            </p>
                        </div>
                    </div>
                    <div class="col-7 col-md-10 d-xs-none mt-md-1 mt-5">
                        <img class="static-image" width="500" src="/dist/v2-hybrid/assets/img/backgrounds/onboarding-assistants/teaser-bg-people.jpg" alt="">
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
